import { MatDialog } from '@angular/material';
import { ArchiveSectorDialogComponent } from './archive-sector-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var ArchiveSectorDialogService = /** @class */ (function () {
    function ArchiveSectorDialogService(matDialog) {
        this.matDialog = matDialog;
    }
    ArchiveSectorDialogService.prototype.open = function (data) {
        return this.matDialog.open(ArchiveSectorDialogComponent, {
            autoFocus: false,
            data: data
        }).afterClosed()
            .toPromise();
    };
    ArchiveSectorDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveSectorDialogService_Factory() { return new ArchiveSectorDialogService(i0.ɵɵinject(i1.MatDialog)); }, token: ArchiveSectorDialogService, providedIn: "root" });
    return ArchiveSectorDialogService;
}());
export { ArchiveSectorDialogService };
